import React from "react";
import {MessageType} from "../../components/MessageBox";
import {UserRole} from "../../../models/account";
import {Tour} from "../../../models/tour";
import {MembershipsInTour} from "../../../models/membership";
import Member from "../../components/Member";
import {useRequiredAccount} from "../../../hooks/AccountContext";

type Props = {
    tour: Tour;
    // ownAccountId: number;
    ownRole: UserRole;
    membershipsInTour: MembershipsInTour;
    onReloadMembershipsInTour: () => void;
    setMessage: (message: MessageType) => void;
};

function TourMemberForm({
                            tour,
                            // ownAccountId,
                            ownRole,
                            membershipsInTour,
                            onReloadMembershipsInTour
                        }: Props) {
    const {
        account
    } = useRequiredAccount();

    const visibleMembers = membershipsInTour.memberships.filter(
        m => m.accountId !== account.id
    );

    console.log(visibleMembers);

    return (
        <div className="member-list scrollbar-area">
            {visibleMembers
                .slice()
                .sort((a, b) => {
                    const fromDiff = a.lastName.localeCompare(b.lastName);
                    if (fromDiff !== 0) return fromDiff;

                    return a.firstName.localeCompare(b.firstName);
                })
                .map((membership, index) => (
                    <div key={membership.accountId}>
                        <Member
                            membership={membership}
                            // ownAccountId={ownAccountId}
                            ownRole={ownRole}
                            tourId={tour.id}
                            handleReload={onReloadMembershipsInTour}
                            validFrom={tour.validFrom}
                            validTo={tour.validTo}
                        />

                        {index < visibleMembers.length - 1 && (
                            <div className="member-divider"></div>
                        )}
                    </div>
                ))}
        </div>
    );
}

export default TourMemberForm;